import enUS from './en-us'
import zhCN from './zh-cn'
import esAR from './es-ar'

export default {
  'en-us': enUS,
  'zh-cn': zhCN,
  'es-ar': esAR
}
